var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { gqlSdk } from '@cta-portal/webapp-common/lib/api/client';
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { RoutePath } from '../../app/router/config';
import lockedIcon from '../../assets/images/icons/common/icon-lock-gold.png';
import revealIcon from '../../assets/images/icons/common/icon-reveal-dark.png';
import cancelIcon from '../../assets/images/icons/common/icon-trash-purple.png';
import Button from '../../components/common/button';
import Table, { CellAlign, CellType } from '../../components/common/table';
import Header from '../../components/pending-actions/header';
import { CurrencyContext } from '../../context/currency';
import { DialogContext } from '../../context/dialog';
import { LoadingContext } from '../../context/loading';
import { UserContext } from '../../context/user';
import { appEnv } from '../../env';
import { useAccountBillingInformation } from '../../hooks/account/use-account-billing-information';
import Layout from '../../layout';
import { DialogType } from '../../types/dialogs';
import { formatDate } from '../../utils/date';
export default function PendingUses() {
    var _a = useI18n(), t = _a.t, i18n = _a.i18n;
    var setServerLoading = useContext(LoadingContext).setServerLoading;
    var setDialogProps = useContext(DialogContext).setDialogProps;
    var _b = useContext(UserContext), user = _b.user, selectedWallet = _b.selectedWallet, balances = _b.balances, localWalletAddress = _b.localWalletAddress;
    var parseCurrencyQuantity = useContext(CurrencyContext).parseCurrencyQuantity;
    var showUpdateBillingInformationDialog = useAccountBillingInformation().showUpdateBillingInformationDialog;
    var _c = useState(undefined), pendingUses = _c[0], setPendingUses = _c[1];
    var _d = useState(undefined), currentBalance = _d[0], setCurrentBalance = _d[1];
    useEffect(function () {
        getPendingUses();
    }, [user]);
    useEffect(function () {
        setCurrentBalance(getBalance());
    }, [balances, selectedWallet]);
    function getPendingUses() {
        return __awaiter(this, void 0, void 0, function () {
            var blockchainPendingCtaTtokenTransferFindMany;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setServerLoading(true);
                        if (!(user === null || user === void 0 ? void 0 : user.billingAddressCountry)) return [3 /*break*/, 2];
                        return [4 /*yield*/, gqlSdk.BlockchainPendingCtaTtokenTransferFindMany()];
                    case 1:
                        blockchainPendingCtaTtokenTransferFindMany = (_a.sent()).blockchainPendingCtaTtokenTransferFindMany;
                        setPendingUses(blockchainPendingCtaTtokenTransferFindMany || []);
                        return [3 /*break*/, 3];
                    case 2:
                        setPendingUses([]);
                        _a.label = 3;
                    case 3:
                        setServerLoading(false);
                        return [2 /*return*/];
                }
            });
        });
    }
    function getBalance() {
        var _a, _b, _c, _d;
        if (selectedWallet && selectedWallet.address === (user === null || user === void 0 ? void 0 : user.mpcWalletAddress)) {
            var currenctBalance = balances && balances.cta
                ? balances.cta.find(function (balance) { return balance.token_address === appEnv.ctaTokenAddress; })
                : undefined;
            return currenctBalance
                ? (_a = parseCurrencyQuantity(currenctBalance.balance, currenctBalance.token_address).base) === null || _a === void 0 ? void 0 : _a.value
                : undefined;
        }
        if (selectedWallet && selectedWallet.address === (user === null || user === void 0 ? void 0 : user.magicLinkWalletAddress)) {
            var currenctBalance = balances && balances.game
                ? balances.game.find(function (balance) { return balance.token_address === appEnv.ctaTokenAddress; })
                : undefined;
            return currenctBalance
                ? (_b = parseCurrencyQuantity(currenctBalance.balance, currenctBalance.token_address).base) === null || _b === void 0 ? void 0 : _b.value
                : undefined;
        }
        if (selectedWallet && selectedWallet.address === (user === null || user === void 0 ? void 0 : user.coldWalletAddress)) {
            var currenctBalance = balances && balances.custom
                ? balances.custom.find(function (balance) { return balance.token_address === appEnv.ctaTokenAddress; })
                : undefined;
            return currenctBalance
                ? (_c = parseCurrencyQuantity(currenctBalance.balance, currenctBalance.token_address).base) === null || _c === void 0 ? void 0 : _c.value
                : undefined;
        }
        if (selectedWallet && selectedWallet.address === localWalletAddress) {
            var currenctBalance = balances && balances.local
                ? balances.local.find(function (balance) { return balance.token_address === appEnv.ctaTokenAddress; })
                : undefined;
            return currenctBalance
                ? (_d = parseCurrencyQuantity(currenctBalance.balance, currenctBalance.token_address).base) === null || _d === void 0 ? void 0 : _d.value
                : undefined;
        }
        return undefined;
    }
    function showCancelPendingUseDialog(uuid) {
        setDialogProps({
            common: {
                title: t('pending-use.cancel.title'),
                close: { text: t('common.back'), action: hideDialog },
                actions: [{ highlighted: true, text: t('common.confirm'), action: function () { return cancelPendingUse(uuid); } }],
            },
            custom: {
                type: DialogType.SIMPLE,
                message: t('pending-use.cancel.confirm-message'),
            },
        });
    }
    function cancelPendingUse(uuid) {
        return __awaiter(this, void 0, void 0, function () {
            var error, result, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setServerLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, gqlSdk.BlockchainPendingCtaTokenTransferCancel({
                                input: { pendingCtaTokenTransferUuid: uuid },
                            })];
                    case 2:
                        result = _a.sent();
                        if (!result.blockchainPendingCtaTokenTransferCancel.success) {
                            error = t('error.generic');
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        if (err_1 instanceof Error) {
                            console.log("[cancelPendingUse] ".concat(err_1));
                            error = t('error.generic');
                        }
                        return [3 /*break*/, 4];
                    case 4:
                        if (!!error) return [3 /*break*/, 6];
                        return [4 /*yield*/, getPendingUses()];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6:
                        setServerLoading(false);
                        setDialogProps({
                            common: {
                                title: error ? t('common.error') : t('pending-use.cancel.title'),
                                close: { text: t('common.back'), action: hideDialog },
                            },
                            custom: {
                                type: DialogType.SIMPLE,
                                message: error || t('pending-use.cancel.success-message'),
                            },
                        });
                        return [2 /*return*/];
                }
            });
        });
    }
    function hideDialog() {
        setDialogProps(undefined);
    }
    var labels = [
        {
            key: 'date',
            label: t('common.date'),
            align: CellAlign.LEFT,
        },
        {
            key: 'amount',
            label: t('common.amount'),
            align: CellAlign.RIGHT,
        },
        {
            key: 'action',
            label: t('common.actions'),
            align: CellAlign.CENTER,
            actionCell: true,
        },
    ];
    var actions = [
        {
            icon: cancelIcon,
            label: t('common.cancel'),
            action: function (id) { return showCancelPendingUseDialog(id); },
            withoutDesktopIcon: true,
            showDisabled: true,
            generateDisability: function (id) {
                var pendingUse = pendingUses === null || pendingUses === void 0 ? void 0 : pendingUses.find(function (item) { return item.uuid === id; });
                if (!pendingUse)
                    return true;
                return Boolean(pendingUse.ctaTokenCountTransferedFormated &&
                    Number.parseFloat(pendingUse.ctaTokenCountTransferedFormated) > 0);
            },
        },
        {
            icon: revealIcon,
            label: t('common.manage'),
            highlighted: true,
            withoutDesktopIcon: true,
            link: {
                routePath: RoutePath.PENDING_USE,
                generateParams: function (id) {
                    return {
                        uuid: id,
                    };
                },
            },
        },
    ];
    var rows = pendingUses
        ? pendingUses.map(function (pendingUse) {
            var _a, _b, _c;
            var price = parseCurrencyQuantity("".concat(BigInt(pendingUse.ctaTokenCountToTransferDeci18) - BigInt(pendingUse.ctaTokenCountTransferedDeci18), "00000000"), appEnv.ctaTokenAddress);
            return {
                id: pendingUse.uuid,
                data: {
                    date: {
                        type: CellType.TEXT,
                        value: formatDate(pendingUse.createdAt, i18n.language),
                    },
                    amount: {
                        type: CellType.PRICE,
                        value: {
                            tokenSymbol: (_a = price.base) === null || _a === void 0 ? void 0 : _a.symbol,
                            value: ((_b = price.base) === null || _b === void 0 ? void 0 : _b.displayValue) || '0',
                            usdValue: ((_c = price.usd) === null || _c === void 0 ? void 0 : _c.displayValue) || '0',
                        },
                        notEnoughCurrency: Boolean(price.base && currentBalance && currentBalance < price.base.value),
                    },
                },
            };
        })
        : [];
    return (_jsx(Layout, { children: _jsxs(_Fragment, { children: [_jsx(Header, { ctaToken: true, title: t('pending-uses.page-title') }), _jsxs(Container, { children: [!(user === null || user === void 0 ? void 0 : user.billingAddressCountry) && (_jsxs(LockedContainer, { children: [_jsx("img", { alt: "locked", src: lockedIcon }), _jsx("p", { children: t('pending-transfer.no-billing-information') }), _jsx(Button, { onClick: showUpdateBillingInformationDialog, children: t('common.manage') })] })), pendingUses && (user === null || user === void 0 ? void 0 : user.billingAddressCountry) && _jsx(Table, { actions: actions, labels: labels, rows: rows })] })] }) }));
}
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  padding: 48px;\n  width: 100%;\n\n  @media screen and (max-width: 824px) {\n    padding: 16px 16px 96px 16px;\n  }\n"], ["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  padding: 48px;\n  width: 100%;\n\n  @media screen and (max-width: 824px) {\n    padding: 16px 16px 96px 16px;\n  }\n"])));
var LockedContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  justify-content: flex-start;\n  width: 600px;\n\n  @media screen and (max-width: 824px) {\n    width: 100%;\n  }\n\n  & > img {\n    height: auto;\n    width: 56px;\n  }\n\n  & > p {\n    font-size: 18px;\n    text-align: center;\n\n    & > span {\n      font-weight: 600;\n    }\n  }\n"], ["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  justify-content: flex-start;\n  width: 600px;\n\n  @media screen and (max-width: 824px) {\n    width: 100%;\n  }\n\n  & > img {\n    height: auto;\n    width: 56px;\n  }\n\n  & > p {\n    font-size: 18px;\n    text-align: center;\n\n    & > span {\n      font-weight: 600;\n    }\n  }\n"])));
var templateObject_1, templateObject_2;
